import { render } from "./AddExerciseSheetQuestion.vue?vue&type=template&id=1878a16a"
import script from "./AddExerciseSheetQuestion.vue?vue&type=script&lang=js"
export * from "./AddExerciseSheetQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__